import React from 'react';

const Divider = () => (
    <div aria-hidden="true" className="my-100 border-b border-decorators-default" />
);

export default Divider;
